import { getEnvVariable } from "./brandConfig";

export const domain = window.location.hostname;
export const BRAND_NAME = getEnvVariable(domain, 'BRAND_NAME');
export const BRAND_DOMAIN = getEnvVariable(domain, 'BRAND_DOMAIN');
// Note: It is the main site url. Ex - apnigame.com, etc.
export const BRAND_DOMAIN_SKIN_URL = 'domain_skin_url';
export const PROVIDER = 'BetFair';
export const PROVIDER_ID = 'BetFair';
export const BACKEND_DOMAIN = 'king18.co';
export const IS_NEW_SCORECARD_ENABLED = getEnvVariable(
    domain,
    'IS_NEW_SCORECARD_ENABLED'
  );

  export const S3_DOMAIN = getEnvVariable(domain, 'S3_DOMAIN');
export const FAVICON = getEnvVariable(domain, 'favicon');
export const HOUSE_NAME = getEnvVariable(domain, 'HOUSE_NAME');
export const FB_PIXEL_IDS: string[] = getEnvVariable(domain, 'FB_PIXEL_IDS') ?? [];
export const GTM_IDS: string[] = getEnvVariable(domain, 'GTM_IDS') ?? [];
export const GTAG_IDS: string[] = getEnvVariable(domain, 'GTAG_IDS') ?? [];
export const META_TITLE: string = getEnvVariable(domain, 'META_TITLE') ?? '';
export const META_DESCRIPTION: string = getEnvVariable(domain, 'META_DESCRIPTION') ?? '';
export const IS_CRICKET100_HOUSE = HOUSE_NAME === 'cricket100';

const SKINS: { label: string; domain: string; disabled?: boolean }[] =
  getEnvVariable(domain, 'skins') ?? [];
// Label of this site in its skin list, Ex - Lotus. The disabled entry marks the current site.
export const CURRENT_SKIN_LABEL: string | undefined = (
  SKINS.find((skin) => skin.domain === domain.replace(/^www\./, '')) ??
  SKINS.find((skin) => skin.disabled)
)?.label;